import { useState } from "react";
import { API } from "../../../config";

export const useImageUpload = () => {
  const [selectedFile, setSelectedFile] = useState(null);
  const [imagePreview, setImagePreview] = useState(null);
  const [uploadError, setUploadError] = useState("");

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    setUploadError("");

    if (!file) {
      setSelectedFile(null);
      setImagePreview(null);
      return;
    }

    // Validate file type
    const validImageTypes = [
      "image/jpeg",
      "image/jpg",
      "image/png",
      "image/gif",
      "image/webp",
    ];
    if (!validImageTypes.includes(file.type)) {
      setUploadError(
        "Please select a valid image file (JPEG, PNG, GIF, or WebP)"
      );
      setSelectedFile(null);
      setImagePreview(null);
      event.target.value = "";
      return;
    }

    // Validate file size (max 5MB)
    const maxSize = 5 * 1024 * 1024;
    if (file.size > maxSize) {
      setUploadError("Image size must be less than 5MB");
      setSelectedFile(null);
      setImagePreview(null);
      event.target.value = "";
      return;
    }

    setSelectedFile(file);

    // Create preview
    const reader = new FileReader();
    reader.onloadend = () => {
      setImagePreview(reader.result);
    };
    reader.readAsDataURL(file);
  };

  const uploadImage = async (image) => {
    try {
      const formData = new FormData();
      formData.append("file", image);
      const response = await fetch(`${API}/image-upload`, {
        method: "POST",
        body: formData,
      });

      if (!response.ok) {
        throw new Error(`Upload failed with status: ${response.status}`);
      }

      const data = await response.json();

      if (!data.result) {
        throw new Error("Upload response did not contain image URL");
      }

      return data.result;
    } catch (error) {
      console.error("Image upload error:", error);
      throw error;
    }
  };

  const resetImageState = () => {
    setSelectedFile(null);
    setImagePreview(null);
    setUploadError("");
  };

  return {
    selectedFile,
    imagePreview,
    uploadError,
    setUploadError,
    handleFileChange,
    uploadImage,
    resetImageState,
  };
};

